import IconArrowDown from 'icons/icon-arrow-down';
import IconArrowUp from 'icons/icon-arrow-up';

import './ResourceListToggle.styles.css';

interface ResourceListToggleProps {
    collapsed: boolean,
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void,
    children: React.ReactNode,
}

const ResourceListToggle = ({ collapsed, onClick, children }: ResourceListToggleProps) => {
    return (
        <div className="resource-list-toggle">
            <span onClick={onClick}>
                { children }

                {
                    collapsed ? <IconArrowDown /> : <IconArrowUp />
                }
            </span>
        </div>
    );
}

export default ResourceListToggle;
